import { useEffect, useState } from "react";
import { SelectPicker } from 'rsuite';
import logoBgdl from "../../assets/media/logos/enlace/ej-isotipo-color.svg";
import Dropdown from 'react-bootstrap/Dropdown';
import { axiosInstance } from "../../components/helpers/axiosInstance";
import { prioridad } from "./TablaTickets";
import { colorFecha } from "./TablaTickets";
import { estatus } from "./TablaTickets";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import TitleTooltip from "../../components/helpers/TitleTooltip";
function BasicExample() {
    return (
        <>
            <Dropdown autoClose={'outside'}>
                <Dropdown.Toggle variant={'light'} bsPrefix={'btn-sm btn-icon btn-active-color-primary'}>
                    <i className="ki-solid ki-dots-horizontal fs-2x"></i>
                </Dropdown.Toggle>

                <Dropdown.Menu renderOnMount={true} bsPrefix={'menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px py-3'}>
                    <Dropdown.Item href="#/action-1" className={'px-3'}>
                        <div className="menu-content text-muted pb-2 px-3 fs-7 text-uppercase" style={{paddingTop: '0.65rem'}}>TITLE</div>
                    </Dropdown.Item>
                    <Dropdown.Item href="#/action-2" className={"px-3"}>
                        <div className="menu-content p-4">
                            <label className="form-check form-switch form-check-custom form-check-solid flex-stack">
                                <span className="form-check-label m-n1">Activar/Desactivar</span>
                                <input className="form-check-input w-30px h-20px" type="checkbox" name="notifications" onChange={(e) => console.log(e.target.value)}/>
                            </label>
                        </div>
                    </Dropdown.Item>
                    <Dropdown.Item href="#/action-3" className={"px-3"}>
                        <button className="btn menu-link p-3" style={{fontSize: '1rem'}}>
                            Registrar Pago
                        </button>
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </>
    );
}

export default function TicketPerfil({
     data
}) {
    const [ticket, setTicket] = useState([]);
    dayjs.extend(relativeTime);

    useEffect(() => {
        axiosInstance.get('/tickets/' + data)
            .then((res) => {
                setTicket(res.data.tickets[0])
            }).catch((err) => console.error(err))
    }, [data]);


    /////////////////// NO FUNCIONA ///////////////////
    // useEffect(() => {
    //     axiosInstance.get("/tickets/" + data + "/comentarios")
    //         .then((res) => {
    //             console.log(res.data.comentarios);
    //         }).catch((err) => console.log(err))
    // }, [data]);

    return (
        <>
            <div className="card card-bordered my-4 mb-xl-5">
                <div className="card-body pt-9 pb-0">
                    <div className="d-flex flex-wrap flex-sm-nowrap mb-3">
                        <div
                            className="d-flex flex-center flex-shrink-0 bg-light rounded w-100px h-100px w-lg-150px h-lg-150px me-7 mb-4">
                            <div className="symbol symbol-150px">
                              <span className="symbol-label fw-bold Mg fs-4x">
                                Mg
                              </span>
                            </div>
                        </div>
                        <div className="flex-grow-1">
                            <div className="d-flex justify-content-between align-items-start flex-wrap mb-2">
                                <div className="d-flex flex-column">
                                    <div className="d-flex align-items-center">
                                      <span className="text-gray-800 fs-2 fw-bold me-3">
                                        DFJURIDICOMA01 - CONSORCIO JURIDICO MARTINEZ SANCHEZ Y ASOCIADOS.
                                      </span>
                                    </div>
                                    <div className="d-flex flex-wrap fs-5 text-gray-500">
                                        <i className="bi bi-envelope fs-4 mt-1 mb-2 me-1"></i>consorciomsya@gmail.com
                                    </div>
                                    <div className="d-flex flex-wrap mb-1 fs-5 text-gray-500">
                                        <i className="ki-outline ki-phone fs-2 text-center"
                                           style={{marginLeft: "-2px", paddingRight: "2px"}}></i>55-5500-0898
                                    </div>
                                </div>
                                <div className="d-flex mb-4">
                                    <div className="me-0">
                                        <BasicExample></BasicExample>
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex">
                                <div className="d-flex flex-wrap">
                                    <div
                                        className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                        <div className="fw-semibold fs-6 text-gray-500">
                                            Paquete:
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="fs-4">
                                                Especial-1500
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                        <div className="fw-semibold fs-6 text-gray-500">
                                            &Uacute;ltimo Pago:
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="fs-4">
                                                Dic. 01, 2024
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                        <div className="fw-semibold fs-6 text-gray-500">
                                            Transferencia:
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="fs-4">
                                                $ 22,668.00 <span className="fs-9">MXN</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="border border-gray-300 border-dashed bg-light-success rounded min-w-125px py-3 px-4 me-6 mb-3">
                                        <div className="fw-semibold fs-6 text-gray-500">
                                            Vigente hasta:
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="fs-4">
                                                Ene. 01, 2025
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                        <div className="fw-semibold fs-6 text-gray-500">
                                            Corte:
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div className="fs-4">
                                                Dias 30
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card card-p-0 card-bordered">
                <div className="card-body ">
                    <div className="d-flex flex-column flex-xl-row p-3 border-bottom">
                        <div className="d-flex align-items-center ps-1 pe-5">
                            <div className="ms-n1 me-2">
                                <img alt="Bolet&iacute;n GDL" className="w-35px" src={logoBgdl}/>
                            </div>
                            <div className="d-flex flex-column fs-6">
                                <span>Enlace Jur&iacute;dico</span>
                                <div className="d-block font-monospace">{ticket.ticket}</div>
                            </div>
                        </div>
                        <div className="flex-lg-row-fluid">
                            <div className="row">
                                <div className="col-md-3">
                                    <EstatusTicket></EstatusTicket>
                                </div>
                                <div className="col-md-3">
                                    <Asignar></Asignar>
                                </div>
                            </div>
                        </div>
                        <div className="flex-column flex-lg-row-auto w-100 mw-lg-400px mw-xxl-500px text-end p-1">
                            <button type={'button'} className="btn btn-lg btn-secondary fw-normal mx-1">
                                Cancelar
                            </button>
                            <button type={'button'} className="btn btn-lg btn-primary fw-normal">
                                Guardar
                            </button>
                        </div>
                    </div>


                    <div className="d-flex flex-column flex-xl-row fd-ticket">
                        <div className="flex-lg-row-fluid">
                            <div className="d-flex flex-wrap py-2 px-1">
                                <div className="d-flex align-items-center fw-semibold p-2">
                                    <div className="fs-7 pe-1">Prioridad:</div>
                                    <span className={"fw-normal badge badge-" + (ticket.estatus === "Concluido" ? 'gray-200' : prioridad(ticket.prioridad).color)}>{prioridad(ticket.prioridad).texto}</span>
                                </div>
                                <div className="d-flex align-items-center fw-semibold p-2">
                                    <div className="fs-7 pe-1">Reportado:</div>
                                    <span className={"fw-normal badge badge-" + colorFecha(ticket.alta)}><span className="fw-bold">{dayjs(ticket.alta).fromNow()}</span>({ticket.alta} HRS)</span>
                                </div>
                                <div className="d-flex align-items-center fw-semibold p-2">
                                    <div className="fs-7 pe-1">Reporta:</div>
                                    <div className="symbol symbol-badge symbol-25px pe-1">
                                        <span className="symbol-label Mg fs-8">Mg</span>
                                    </div>
                                    <div className="text-muted fs-7">Octavio Hernandez</div>
                                </div>
                                <div className="d-flex align-items-center fw-semibold p-2">
                                    <div className="fs-7 pe-1">Atiende:</div>
                                    <div className="symbol symbol-badge symbol-25px pe-1">
                                        <span className="symbol-label Mg fs-8">Mg</span>
                                    </div>
                                    <div className="text-muted fs-7">Octavio Hernandez</div>
                                </div>
                            </div>
                            <div className="separator separator-dashed"></div>
                            <div className="d-flex p-3 align-items-center">
                                <TitleTooltip title={ticket.estatus} placement={'top'}>
                                    <i className={"bi bi-ticket-perforated-fill mt-n1 me-3 fs-4qx  text-" + estatus(ticket.estatus)}></i>
                                </TitleTooltip>
                                <div className="fw-normal fs-2 line-clamp-2">
                                    {ticket.asunto}
                                </div>
                            </div>


                            <div className="separator"></div>
                            <div className="px-8 py-5 fs-4">
                                Hola:<br/>
                                <br/>
                                {
                                    ticket.descripcion
                                }
                            </div>

                            <div className="separator separator-dashed"></div>

                            <div className="d-flex align-items-center px-3 py-5">
                                <i className="ki-solid ki-paper-clip fs-1 me-1 "></i>
                                <div className="fw-normal fs-4">
                                    Adjuntos
                                </div>
                            </div>


                            <div className="px-8">


                                <div className="row g-10 row-cols-2 row-cols-lg-5">
                                    <div className="col">
                                        <a className="d-block overlay" data-fslightbox="lightbox-hot-sales" href="../../assets/media/">
                                            <div
                                                className="overlay-wrapper bgi-no-repeat bgi-position-center bgi-size-cover card-rounded min-h-175px"
                                                style={{backgroundImage : "url('assets/media/stock/900x600/16.jpg')"}}></div>
                                            <div className="overlay-layer card-rounded bg-dark bg-opacity-25">
                                                <i className="ki-duotone ki-eye fs-3x text-white">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                    <span className="path3"></span>
                                                </i>
                                            </div>
                                        </a>
                                    </div>
                                    <div className="col">
                                        <a className="d-block overlay" data-fslightbox="lightbox-hot-sales"
                                           href="../../assets/media/">
                                            <div
                                                className="overlay-wrapper bgi-no-repeat bgi-position-center bgi-size-cover card-rounded min-h-175px"
                                                style={{backgroundImage: "url('assets/media/stock/900x600/13.jpg')"}}></div>
                                            <div className="overlay-layer card-rounded bg-dark bg-opacity-25">
                                                <i className="ki-duotone ki-eye fs-3x text-white">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                    <span className="path3"></span>
                                                </i>
                                            </div>
                                        </a>
                                    </div>
                                    <div className="col">
                                        <a className="d-block overlay" data-fslightbox="lightbox-hot-sales"
                                           href="../../assets/media/">
                                            <div
                                                className="overlay-wrapper bgi-no-repeat bgi-position-center bgi-size-cover card-rounded min-h-175px"
                                                style={{backgroundImage : "url('assets/media/stock/900x600/19.jpg')"}}></div>
                                            <div className="overlay-layer card-rounded bg-dark bg-opacity-25">
                                                <i className="ki-duotone ki-eye fs-3x text-white">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                    <span className="path3"></span>
                                                </i>
                                            </div>
                                        </a>
                                    </div>
                                    <div className="col">
                                        <a className="d-block overlay" data-fslightbox="lightbox-hot-sales"
                                           href="../../assets/media/">
                                            <div
                                                className="overlay-wrapper bgi-no-repeat bgi-position-center bgi-size-cover card-rounded min-h-175px"
                                                style={{backgroundImage : "url('assets/media/stock/900x600/15.jpg')"}}></div>
                                            <div className="overlay-layer card-rounded bg-dark bg-opacity-25">
                                                <i className="ki-duotone ki-eye fs-3x text-white">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                    <span className="path3"></span>
                                                </i>
                                            </div>
                                        </a>
                                    </div>
                                    <div className="col">
                                        <a className="d-block overlay" data-fslightbox="lightbox-hot-sales"
                                           href="../../assets/media/">
                                            <div
                                                className="overlay-wrapper bgi-no-repeat bgi-position-center bgi-size-cover card-rounded min-h-175px"
                                                style={{backgroundImage: "url('assets/media/stock/900x600/12.jpg')"}}></div>
                                            <div className="overlay-layer card-rounded bg-dark bg-opacity-25">
                                                <i className="ki-duotone ki-eye fs-3x text-white">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                    <span className="path3"></span>
                                                </i>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex-column flex-lg-row-auto w-100 mw-lg-400px mw-xxl-500px border-start">
                            <div className="d-flex align-items-center px-4 py-2">
                                <i className="bi bi-activity text-info fs-1 me-3 "></i>
                                <div className="fw-normal fs-4">
                                    Actividad
                                </div>
                            </div>
                            <div className="separator separator-dashed"></div>
                        </div>
                    </div>
                </div>
            </div>
            </>
    );
}


function Asignar(){

    const data = [{nombre: 'Octavio Hernandez', avatar: 'Mg', valor: "magnanimus"},
                         {nombre: 'Alberto Coss', avatar: 'Mk', valor: "mikado"},
                         {nombre: 'Mario Aguilar', avatar: 'M', valor: "mario"},
                         {nombre:'Noemi Ramirez', avatar: 'N', valor: "noemi"}].map(
        item => ({ label: item.nombre, value: item.valor, avatar: item.avatar })
    );

    return(
        <>
            <style type={'text/css'}>
                {`
                    #reasignar > .rs-stack{
                        display : block!important;
                    }
                    #reasignar-label{
                        display : flex!important;
                    }
                    
                    .labelSelect {
                        font-size : 1rem;
                        color: rgba(var(--bs-body-color-rgb),.65);
                        transform: scale(.85) translateY(-.5rem) translateX(.15rem);
                        position : absolute;
                        left : 0;
                    }
                    
                    .rs-picker-toggle-label::after {
                        display : none!important;
                    }
                    
                    #reasignar > .rs-stack > div:nth-child(2){
                        padding-top : 1.25rem;
                    }
                `}
            </style>
            <SelectPicker
                label={<div className={'labelSelect'}>Asignar / Reasignar a:</div>}
                menuClassName={'hola'}
                id={"reasignar"}
                name={"reasignar"}
                data={data}
                valueKey={"value"}
                labelKey={'label'}
                placeholder={'Usuario...'}
                cleanable={false}
                style={{width: "100%"}}
                menuStyle={{width:'auto'}}
                renderMenuItem={
                    /**
                     * @param label
                     * @param item
                     * @param item.avatar
                     * @returns {JSX.Element}
                     */
                (label, item) => {
                    return (
                        <div className="d-flex align-items-center">
                            <div className="symbol symbol-20px me-3">
                                <span className={"symbol-label fs-8 " + item.avatar}>{item.avatar}</span>
                            </div>
                            <div className="d-flex flex-column">
                                <span className="fs-6 fw-bold lh-1 text-capitalize">{label}</span>
                            </div>
                        </div>
                    );
                }}
                renderValue={
                    /**
                     * @param value
                     * @param item
                     * @prop item.avatar
                     * @prop item.label
                     * @returns {JSX.Element}
                     */
                (value, item) => {
                    return (
                        <div className="d-flex align-items-center">
                            <div className="symbol symbol-20px me-3">
                                <span className={"symbol-label fs-8 " + item.avatar}>{item.avatar}</span>
                            </div>
                            <div className="d-flex flex-column">
                                <span
                                    className="fs-6 fw-bold lh-1 text-capitalize">{item.label}
                                </span>
                            </div>
                        </div>
                    );
                }}
            />
        </>
    );
}


function EstatusTicket() {

    const data = [
        {label: 'Reportado', value: 'reportado'},
        {label: 'Cocinándose', value: 'cocinandose'},
        {label: 'Pausado', value: 'pausado'},
        {label: 'Postergado', value: 'postergado'},
        {label: 'Atendido', value: 'atendido'},
        {label: 'Concluido', value: 'concluido'},
        {label: 'Archivado', value: 'archivado'},
    ]

    // rs-picker-select-menu-item-active::after{
    //     content: " (" <i class="bi bi-check"></i> ")";
    // }

    return (
        <>
            <style type={'text/css'}>
                {`
                    #estatus{
                        background-color : #e6f5ff!important;
                    }
                    
                    #estatus > .rs-stack{
                        display : block!important;
                    }
                    #estatus-label{
                        display : flex!important;
                    }
                    .labelSelect {
                        font-size : 1rem;
                        color: rgba(var(--bs-body-color-rgb),.65);
                        transform: scale(.85) translateY(-.5rem) translateX(.15rem);
                        position : absolute;
                        left : 0;
                    }
                    #estatus > .rs-stack > div:nth-child(2){
                        padding-top : 1.25rem;
                    }
                    
                    #estatus-listbox > div > span.rs-picker-select-menu-item-active{
                        color : var(--bs-component-hover-color);
                    }
                    
                    #estatus-listbox > div > span.rs-picker-select-menu-item-active::after{
                        background-color: var(--bs-component-hover-color);
                        content: "";
                        display: block;
                        height: .75rem;
                        -webkit-mask-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 11'%3E%3Cpath fill='var(--bs-component-hover-color)' d='M4.896 6.498 2.795 4.265A1.33 1.33 0 0 0 .857 6.088l3.893 4.138a1 1 0 0 0 1.457 0l6.936-7.373a1.33 1.33 0 0 0-1.938-1.823L6.061 6.498a.8.8 0 0 1-1.165 0'/%3E%3C/svg%3E");
                        mask-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 11'%3E%3Cpath fill='var(--bs-component-hover-color)' d='M4.896 6.498 2.795 4.265A1.33 1.33 0 0 0 .857 6.088l3.893 4.138a1 1 0 0 0 1.457 0l6.936-7.373a1.33 1.33 0 0 0-1.938-1.823L6.061 6.498a.8.8 0 0 1-1.165 0'/%3E%3C/svg%3E");
                        mask-position: center;
                        -webkit-mask-position: center;
                        mask-repeat: no-repeat;
                        -webkit-mask-repeat: no-repeat;
                        width: .75rem;
                    }
                    
                    #estatus-listbox > div > span.rs-picker-select-menu-item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                    }
                `}
            </style>
            <SelectPicker
                label={<div className={'labelSelect ps-2'}>Estatus:</div>}
                data={data}
                id={'estatus'}
                name={'estatus'}
                valueKey={'value'}
                labelKey={'label'}
                placeholder={'Seleccionar...'}
                cleanable={false}
                searchable={false}
                style={{width: "100%"}}
                menuStyle={{width:'auto'}}
                renderMenuItem={(label) => {
                    return (
                        <span className={'d-flex align-items-center px-1 text-start'}>{label}</span>
                    );
                }}
                renderValue={(value, item) => {
                    return (
                        <span className={'d-flex align-items-center text-start'}>{item.label}</span>
                    )
                }}
            >
            </SelectPicker>
        </>
    );
}
